import React from "react";
import { useSelector } from "react-redux";
import { Appstore } from "../../../redux";

/** Invisible full-screen layer that blocks pointer events while requests are in flight. */
const LoadingBlocker: React.FC = () => {
  const isBlocking = useSelector(
    (state: Appstore) => state.loader.isBlocking,
  );

  if (!isBlocking) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 z-[9999] bg-transparent"
      aria-hidden="true"
    />
  );
};

export default LoadingBlocker;
